<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item prop="schoolId">
                <span slot="label" ><a-tooltip>{{$t('学校')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                <a-select show-search :filter-option="schoolFilter" :placeholder="$t('请选择')+$t('学校')" style="width: 100%" v-model="queryParam.schoolId" allowClear>
                  <a-select-option v-for="(item, index) in this.schoolList" :value="item.id+''" :key="index">
                    {{ item.schoolName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item  prop="stage">
                <span slot="label" ><a-tooltip>{{$t('学段')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                <a-select :placeholder="$t('请选择')+$t('学段')" style="width: 100%" v-model="queryParam.stage" allowClear>
                  <a-select-option v-for="(item, index) in this.customDict.SchoolStageEnum" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('创建开始时间')" prop="createBeginTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                     :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                     valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('创建结束时间')" prop="createEndTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                     :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                     valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd('0')" v-hasPermi="['school:schoolgrade:add']">
          <a-icon type="plus" />{{$t('新增')}}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['school:schoolgrade:edit']">
          <a-icon type="edit" />{{$t('修改')}}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['school:schoolgrade:remove']">
          <a-icon type="delete" />{{$t('删除')}}
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['school:schoolgrade:export']">
          <a-icon type="download" />{{$t('导出')}}
        </a-button>
        <a-button type="dashed" @click="excelHandleOpen()">
          <a-icon type="import" />{{$t('导入')}}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form :school-list="schoolList"
        ref="createForm"
        @ok="getList"
      />
      <import-excel ref="importExcel" @ok="getList" />
      <!-- 数据展示 -->
      <a-table
        v-table-sticky="{ fixedTop: 64 }"
        :scroll="{ x: '1200' }"
        id="draggable-table"
        class="draggable-table"
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :expanded-row-keys.sync="expandedRowKeys"
      >
        <div slot="sort" slot-scope="text, record">
          <a-input-number v-model="record.sort" :min="0" :max="9999999" @blur="onSortChange(record)"></a-input-number>
        </div>
        <span slot="stage" slot-scope="text, record">
          <custom-dict-tag :options="customDict.SchoolStageEnum" :value="record.stage"/>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['school:schoolgrade:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['school:schoolgrade:edit']">
             <a-icon type="edit" />{{$t('修改')}}
          </a>
          <a-divider type="vertical" v-hasPermi="['school:schoolgrade:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['school:schoolgrade:remove']">
            <a-icon type="delete" />{{$t('删除')}}
          </a>
          <a-divider type="vertical" v-hasPermi="['school:schoolgrade:add']" />
          <a @click="$refs.createForm.handleAdd(record.id)" v-if="record.parentId==='0' " v-hasPermi="['school:schoolgrade:add']">
             <a-icon type="plus" />添加班级
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageSchoolGrade,updateSort, delSchoolGrade } from '@/api/school/schoolGrade'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import {listSchool} from "@/api/school/school";
import ImportExcel from "./modules/ImportExcel.vue";

export default {
  name: 'SchoolGrade',
  components: {
    ImportExcel,
    CustomDictTag,
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      expandedRowKeys: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      schoolList: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        schoolId: undefined,
        stage: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('名称'),
          dataIndex: 'gradeName',
          align: 'left'
        },
        {
          title: this.$t('学校名称'),
          dataIndex: 'schoolName',
          align: 'center'
        },
        {
          title: this.$t('学段'),
          dataIndex: 'stage',
          scopedSlots: { customRender: 'stage' },
          align: 'center'
        },
        {
          title: this.$t('排序'),
          dataIndex: 'sort',
          scopedSlots: { customRender: 'sort' },
          align: 'center'
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: this.$t('备注'),
          dataIndex: 'remark',
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '14%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getRouteList()
    this.getSchoolList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
    $route:'getRouteList'
  },
  methods: {
    moment,
    /** 递归获取所有有子级的行 key，用于展开所有子级 */
    getAllExpandableRowKeys(list) {
      const keys = []
      const collect = (rows) => {
        if (!rows || !Array.isArray(rows)) return
        rows.forEach(row => {
          if (row.children && row.children.length > 0) {
            keys.push(row.id)
            collect(row.children)
          }
        })
      }
      collect(list)
      return keys
    },
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    /** 查询年级班级列表 */
    getList () {
      this.loading = true
     pageSchoolGrade(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.expandedRowKeys = this.getAllExpandableRowKeys(this.list)
        this.loading = false
      })
    },

    getSchoolList () {
      this.loading = true
      listSchool({}).then(response => {
        this.schoolList = response.data
      })
    },
    schoolFilter(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    onSortChange(record) {
      updateSort({"id":record.id,"sort":record.sort}).then(response=>{
        this.getList();
      });
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        schoolId: undefined,
        stage: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    getRouteList() {
      let query = this.$route.query;
      if (query.schoolId) {
        this.queryParam.schoolId = query.schoolId
      }
      this.getList()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      let reqData = {"idList":this.ids}
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk () {
          return delSchoolGrade(reqData)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(message,3)
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    excelHandleOpen() {
      if (!this.queryParam.schoolId) {
        this.$message.error("请先选择学校")
        return
      }
      this.$refs.importExcel.importExcelHandleOpen(this.queryParam.schoolId);
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('biz/admin/school/grade/export',
            that.queryParam
          , `年级班级_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
